enum Lookup {
	BasketProcessSteps = 'basketProcessSteps',
	Brands = 'brand',
	BrandOwner = 'brandOwner', // static
	Currencies = 'currency',
	MarkupTypes = 'defaultMarkupType',
	ExclusionFilters = 'exclusionFilter',
	EnabledFilters = 'enabledFilter',
	MarketBasketSource = 'marketBasketSource', // static
	MarketSegments = 'marketSegment',
	// MarkupTypes = 'MarkupTypes',
	MatchTypeFilters = 'matchTypeFilter',
	ProgramTypes = 'programType',
	PurchaseGroups = 'purchaseGroupField',
	Operators = 'operator',
	ReviewTypes = 'reviewType',
	SameManufacturerSwitchFilters = 'sameManufacturerSwitchFilter',
	SwitchCandidateInfo = 'switchCandidateInfo',
}

export default Lookup
